import React, { FC, useCallback, useMemo } from 'react';
import { Loader, Text, Timeline } from '@wix/design-system';
import { CircleSmallFilled, StatusCompleteFilled } from '@wix/wix-ui-icons-common';
import styles from './ProgressSteps.scss';

type Props = {
  steps: string[];
  currentStepIndex: number;
};

export const ProgressSteps: FC<Props> = ({ steps, currentStepIndex }) => {
  const renderLabel = useCallback(
    (step: string, index: number) => {
      const isStale = index > currentStepIndex;
      return (
        <div className={styles.progressStepLabel}>
          <Text secondary={isStale} light={isStale}>
            {step}
          </Text>
        </div>
      );
    },
    [currentStepIndex],
  );

  const getPrefix = useCallback(
    (index: number) => {
      const isCompleted = index < currentStepIndex;
      const isActive = index === currentStepIndex;

      if (isCompleted) {
        return <StatusCompleteFilled />;
      }

      if (isActive) {
        return <Loader size="tiny" />;
      }

      return <CircleSmallFilled />;
    },
    [currentStepIndex],
  );

  const items = useMemo(() => {
    return steps.map((step, index) => ({
      label: renderLabel(step, index),
      customPrefix: <div className={styles.progressStepPrefix}>{getPrefix(index)}</div>,
    }));
  }, [steps, getPrefix, renderLabel]);

  return <Timeline gap="40px" items={items} />;
};
